import { Box, Skeleton } from '@mui/material';
import React, { ReactNode } from 'react';
import EditablePanel, { EditablePanelProps } from '../../../../components/EditablePanel';
import { FormProvider } from '../../../../form/FormContext';
import FormWidget from '../../../../form/FormWidget';
import { FORM_WIDGET_COMPONENTS } from '../../../../form/formConstants';
import { APPROVAL_EDITABLE_PANEL_CONTENT_SX } from '../../../constants';
import { useReviewApprovalContext } from '../../hooks/useReviewApprovalContext';
import CreateApprovalFormEditablePanelHeader from '../CreateApprovalFormEditablePanelHeader';

const headerActionsSx = { flex: 1 };

export type ApprovalSummaryViewProps = Pick<EditablePanelProps, 'isCollapsable' | 'defaultCollapsed'>;

export default function ApprovalSummaryView({ isCollapsable, defaultCollapsed }: ApprovalSummaryViewProps) {
    const { isFetchingApprovalData, approvalData } = useReviewApprovalContext();

    let summaryContent: ReactNode = null;

    if (isFetchingApprovalData) {
        summaryContent = <Skeleton variant="rounded" width="100%" height={80} />;
    } else if (approvalData) {
        summaryContent = (
            <FormProvider state={approvalData} disableFunctionalStateUpdate>
                <FormWidget name="summary" component={FORM_WIDGET_COMPONENTS.richText} readOnly isEditing={false} />
            </FormProvider>
        );
    }

    return (
        <EditablePanel
            Header={<CreateApprovalFormEditablePanelHeader titleToken="approval.summary.header" />}
            isCollapsable={isCollapsable}
            defaultCollapsed={defaultCollapsed}
            headerActionsSx={headerActionsSx}
        >
            <Box sx={APPROVAL_EDITABLE_PANEL_CONTENT_SX}>{summaryContent}</Box>
        </EditablePanel>
    );
}
